import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { apiFetch } from 'utils/apiUtils.ts';
import { Role } from 'queries/fetch/fetchTeamMembers.ts';

interface UpdateUserPermissionsVariables {
  teamId: string;
  userId: string;
  permissions: Role[];
}

interface UpdateTeamRoutingPlansResponse {
  message: string;
}

export default function useUpdateUserPermissions() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['userPermissions'],
    mutationFn: async ({ teamId, userId, permissions }: UpdateUserPermissionsVariables) => apiFetch<UpdateTeamRoutingPlansResponse>({
      path: `team/${teamId}/user/${userId}/permissions`,
      method: 'PUT',
      accessToken: String(tokens.accessToken),
      body: { permissions },
    }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['teamMembers', { teamId: variables.teamId }],
      });
    },
  });
}
